import useTranslation from "next-translate/useTranslation"

import { ChallengeState } from "@api/schema"

interface IProps {
  state: ChallengeState
}

/**
 * This component creates a colored text based on the given ChallengeState
 */
const ChallengeStateText: React.FC<IProps> = ({ state }: IProps) => {
  const { t } = useTranslation("common")

  const className = state === ChallengeState.Open
    ? "text-success"
    : (state === ChallengeState.Finished
      ? "text-muted"
      : "text-warning")

  return <span className={className}>{t("challenge.state." + state)}</span>
}

export default ChallengeStateText